// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ycjhc","image":"Card_image__KPldk","info":"Card_info__iim04","title":"Card_title__1tHSH","subtitle":"Card_subtitle__V01I-","feedback":"Card_feedback__K3O3O"};